import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

interface HeaderTextBlockProps {
    header: ReactNode;
    subHeader?: ReactNode;
    leftAligned?: boolean;
    cta?: ReactNode;
}

const headerTextBlock = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingBlockStart: token("space.600"),
    paddingBlockEnd: token("space.800"),
    [media.below.sm]: {
        alignItems: "center"
    }
});

const headerText = css({
    textAlign: "center",
    margin: 0,
    padding: "0 0 16px 0"
});

const headerSubText = css({
    textAlign: "center",
    margin: 0,
    padding: "0 0 16px 0"
});

const leftAlignedStyle = css({
    textAlign: "left"
});

const button = css({
    textAlign: "center",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        fontWeight: 400,
        color: wacToken("color.neutral.light0")
    }
});

export const HeaderTextBlock = ({
    header,
    subHeader,
    leftAligned,
    cta
}: HeaderTextBlockProps) => {
    return (
        <div css={headerTextBlock}>
            <h1
                css={[headerText, leftAligned && leftAlignedStyle]}
                className="superhero-contrast"
            >
                {header}
            </h1>
            {subHeader && (
                <p
                    css={[headerSubText, leftAligned && leftAlignedStyle]}
                    className="body-lg"
                >
                    {subHeader}
                </p>
            )}
            {cta && <div css={button}>{cta}</div>}
        </div>
    );
};

export default HeaderTextBlock;
